import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// Les appels à Supabase ont été remplacés par fetch vers l'API PHP
import { useTranslation } from '../useTranslation';
import GLightbox from 'glightbox';
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'glightbox/dist/css/glightbox.min.css';

const Home = () => {
const testImage = new Image();
testImage.src = '../img/event-birthday.jpg';
testImage.onload = function() {
  console.log('✅ Image chargée avec succès');
};
testImage.onerror = function() {
  console.log('❌ Erreur de chargement de l\'image');
  console.log('Chemin testé :', testImage.src);
};
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const { t } = useTranslation();
  const [products, setProducts] = useState([]);
  const [galleryImages, setGalleryImages] = useState([]);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState({
    products: true,
    gallery: true,
    events: true
  });

  useEffect(() => {
    const lightbox = GLightbox({
      selector: '.glightbox'
    });
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      mirror: false
    });
    return () => {
      lightbox.destroy();
      AOS.refresh();
    };
  }, []);

  // Fetch products
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch("/api/products.php?limit=3");
        const json = await response.json();
        if (json.success) {
          setProducts(json.data);
        } else {
          console.error("Error fetching products:", json.error);
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoading(prev => ({ ...prev, products: false }));
      }
    };

    fetchProducts();
  }, []);

  // Fetch chalet images
  useEffect(() => {
    const fetchGalleryImages = async () => {
      try {
        const response = await fetch("/api/category_images.php?category=terroir&limit=3");
        const json = await response.json();
        if (json.success) {
          setGalleryImages(json.data);
        } else {
          console.error("Error fetching gallery images:", json.error);
        }
      } catch (error) {
        console.error("Error fetching gallery images:", error);
      } finally {
        setLoading(prev => ({ ...prev, gallery: false }));
      }
    };

    fetchGalleryImages();
  }, []);

  // Fetch events
  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await fetch("/api/events.php?limit=3");
        const json = await response.json();
        if (json.success) {
          setEvents(json.data);
        } else {
          console.error("Error fetching events:", json.error);
        }
      } catch (error) {
        console.error("Error fetching events:", error);
      } finally {
        setLoading(prev => ({ ...prev, events: false }));
      }
    };

    fetchEvents();
  }, []);

  return (
    <>
  <style>{`
    body {
      padding-top: 13px !important;
      background: #0c0b09;
    }
  `}</style>
      {/* Hero Section */}
      <section id="hero" className="d-flex align-items-center">
        <div className="container position-relative text-center text-lg-start" data-aos="zoom-in" data-aos-delay="100">
          <div className="row">
            <div className="col-lg-8">
              <h1>{t('welcomeTo')} <span>Numidya</span></h1>
              <h2>{t('descriptionWelcoming')}</h2>
              <div className="btns">
                <a href="/galerie" className="btn-menu animated fadeInUp scrollto">{t('ourGallery')}</a>
                <a href="/boutique" className="btn-book animated fadeInUp scrollto">{t('ourProducts')}</a>
              </div>
            </div>
            <div className="col-lg-4 d-flex align-items-center justify-content-center position-relative" data-aos="zoom-in" data-aos-delay="200">
              <a href="https://www.youtube.com/watch?v=GlrxcuEDyF8" className="glightbox play-btn"></a>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" class="about">
      <div class="container" data-aos="fade-up">

        <div class="row">
          <div class="col-lg-6 order-1 order-lg-2" data-aos="zoom-in" data-aos-delay="100">
            <div class="about-img">
              <img src="assets/img/about.jpg" alt=""/>
            </div>
          </div>
        <div className="col-lg-6 pt-4 pt-lg-0 order-2 order-lg-1 content">
  <h3>{t('homeSectionTitle')}</h3>
  <p className="fst-italic">
    {t('homeSectionDescription')}
  </p>
  <ul>
    <li><i className="bi bi-check-circle"></i> {t('homeFeature1')}</li>
    <li><i className="bi bi-check-circle"></i> {t('homeFeature2')}</li>
    <li><i className="bi bi-check-circle"></i> {t('homeFeature3')}</li>
  </ul>
  <p>
    {t('homeSectionConclusion')}
  </p>
</div>
        </div>
      </div>
    </section>

      {/* Products Section */}
      <section id="products" className="products">
        <div className="container" data-aos="fade-up">
          <div className="section-title">
            <h2>{t('productsTitle')}</h2>
            <p>{t('productsSubtitle')}</p>
          </div>

          <div className="row">
            {loading.products ? (
              <div className="col-12 text-center py-4">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : products.length > 0 ? (
              <>
                {products.map((product, index) => (
                  <div className="col-lg-4 col-md-6" key={product.id} data-aos="zoom-in" data-aos-delay={100 * index}>
                    <div className="member">
                      <div className="img-container">
                        <img
                          src={product.image_url}
                          className="img-fluid"
                          alt={product.name}
                          style={{
                            width: '100%',
                            height: '300px',
                            objectFit: 'cover'
                          }}
                        />
                        <div className="member-info">
                          <div className="member-info-content">
                            <h4>{product.name}</h4>
                            <span>{product.price} DT</span>
                          </div>
                          <div className="social">
                            <Link to={`/produitDetails/${product.id}`} className="btn-details">
                              <i className="bi bi-eye"></i> {t('voirPlus')}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                <div className="col-12 text-center mt-4">
                  <Link to="/boutique" onClick={scrollToTop} className="btn-explore-more">
                    <i className="bi bi-arrow-right"></i> {t('MoreProducts')}
                  </Link>
                </div> 
              </>
            ) : (
              <div className="col-12 text-center py-4">
<p className="lead">{t('noProducts')}</p>              </div>
            )}
          </div>
        </div>
      </section>

      {/* Chalet Gallery Section */}
      <section id="events" className="events">
        <div className="container" data-aos="fade-up">
          <div className="section-title">
            <h2>{t('galleryTitle')}</h2>
<p>{t('GalleryOilSubtitle')}</p>
          </div>
        </div>

        <div className="container-fluid" data-aos="fade-up" data-aos-delay="100">
          {loading.gallery ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : galleryImages.length > 0 ? (
            <>
              <div className="row g-0">
                {galleryImages.map((image, index) => (
                  <div className="col-lg-4 col-md-6" key={image.id}>
                    <div className="gallery-item h-100">
                      <a href={image.url} className="glightbox" data-gall="gallery-chalet">
                        <img 
                          src={image.url} 
                          alt={`Gallery ${index + 1}`} 
                          className="img-fluid"
                          style={{ 
                            height: "300px", 
                            width: "100%", 
                            objectFit: "cover",
                            objectPosition: "center"
                          }}
                        />
                      </a>
                    </div>
                  </div>
                ))}
              </div>
              <div className="text-center mt-4">
                <Link to="/galerie" onClick={scrollToTop} className="btn-explore-more">
                  <i className="bi bi-images"></i> {t('MorePhotos')}
                </Link>
              </div>
            </>
          ) : (
            <div className="text-center py-4">
             <p className="lead">{t('noOilgalleryImages')}</p>
            </div>
          )}
        </div>
      </section>

      
    </>
  );
};

export default Home;